export const cleanObj = (obj) => {
  if (!obj) {
    return
  }
  const propNames = Object.getOwnPropertyNames(obj)
  for (const name of propNames) {
    const property = obj[name]
    if (property === null || property === undefined || property === '') {
      delete obj[name]
    } else if (typeof property === 'object') {
      if (Object.keys(property).length === 0) {
        delete obj[name]
      } else {
        cleanObj(property)
      }
    }
  }
  return obj
}

export const groupByKey = (arr, getKey, singleItem = false) => {
  if (!arr) {
    return {}
  }
  return arr.reduce((acc, item) => {
    const key = getKey(item)
    if (singleItem) {
      acc[key] = item
    } else {
      if (hasOwnProperty.call(acc, key)) {
        acc[key].push(item)
      } else {
        acc[key] = [item]
      }
    }
    return acc
  }, {})
}

export const partitionOnCondition = (arrays, check) => {
  return arrays.reduce(
    (result, item) => {
      if (check(item)) {
        result[0].push(item)
      } else {
        result[1].push(item)
      }
      return result
    },
    [[], []]
  )
}

/**
 * Convert an object's keys from snake_case to camelCase
 * @param {Object|String} data string or keys of object are named in form of snake
 * @param {number} [depth] to which level of keys should it process
 * @return {Object|String} string or keys of object are named in form of camel case
 */
export const snakeToCamel = function (data, depth = 1) {
  if (isObject(data)) {
    return _processKeys(data, _camelize, depth)
  } else {
    return _camelize(data)
  }
}

/**
 * Convert an object's keys from camelCase to snake_case
 * @param {Object|String} data string or keys of object are named in form of camel case
 * @param {number} depth to which level of keys should it process
 * @return {Object|String} string or keys of object are named in form of snake
 */
export const camelToSnake = function (data, depth = 1) {
  if (isObject(data)) {
    return _processKeys(data, _snakelize, depth)
  } else {
    return _snakelize(data)
  }
}

export const getDifference = (array1, array2) => {
  const s2 = new Set(array2)
  return array1.filter((a) => !s2.has(a))
}

export const isArrayEqual = (array1, array2) => {
  if (!array1 || !array2) {
    return false
  }
  const diff1 = getDifference(array1, array2)
  const diff2 = getDifference(array2, array1)
  return [...diff1, ...diff2].length === 0
}

function isObject(obj) {
  return !!obj && typeof obj === 'object'
}

function isNumber(obj) {
  return !!obj && typeof obj === 'number'
}

// snakelize a string formed in underscore
function _snakelize(key) {
  let separator = '_'
  let split = /(?=[A-Z])/

  return key.split(split).join(separator).toLowerCase()
}

// camelize a string formed in underscore
function _camelize(key) {
  if (isNumber(key)) {
    return key
  }
  key = key.replace(/[\-_\s]+(.)?/g, function (match, ch) {
    return ch ? ch.toUpperCase() : ''
  })
  // Ensure 1st char is always lowercase
  return key.substr(0, 1).toLowerCase() + key.substr(1)
}

// camelize/snakelize keys of an object
// @param {number} depth to which level of keys should it process
function _processKeys(obj, processer, depth) {
  if (depth === 0 || !isObject(obj)) {
    return obj
  }

  let result = {}
  let keys = Object.keys(obj)

  for (let i = 0; i < keys.length; i++) {
    result[processer(keys[i])] = _processKeys(obj[keys[i]], processer, depth - 1)
  }

  return result
}

export class Observer {
  init = false
  value = null
  callbacks = []
  watch(value) {
    if (!this.init) {
      this.init = true
    } else if (this.value !== value) {
      this.callbacks.forEach((cb) => {
        cb(this.value, value)
      })
    }
    this.value = value
    return this
  }
  onChange(func) {
    this.callbacks.push(func)
  }
}
